module.exports = __webpack_public_path__ + "static/unclesam-0b90e55861b165265ead451cd4c4007e.jpeg";